import styled from 'styled-components'

export const DropdownContent = styled.div`
  min-width: 240px;
`
